<script setup lang="ts">
import { ref, toRefs } from 'vue';
import Step from './Step.vue';

interface PropsInterface {
  id: number;
}

const props = defineProps<PropsInterface>();
const { id } = toRefs(props);

const isSelectedClass = (key: number) => {
  return key === id.value ? 'selected' : '';
};

const steps = ref([
  { title: 'Add Tenant', id: 0 },
  { title: 'Add Organization', id: 1 },
  { title: 'Add Admin', id: 2 },
]);
</script>

<template>
  <div class="relative pb-3 steps-container">
    <hr class="w-full bg-white absolute rule right-0 left-0" />
    <div class="mx-4 flex flex row justify-content-between">
      <Step v-for="step in steps" :key="step.id" :class-name="isSelectedClass(step.id)" :step="step" />
    </div>
  </div>
</template>

<style scoped lang="scss">
.steps-container {
  margin: 0rem -1.5rem;
  width: calc(100% + 3rem);
}
.rule {
  height: 2px;
  border: white;
  z-index: 0;
  top: 12px;
}
</style>
